import React, { useState, useEffect } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import helper from '../Shared/helper'
import defaultPhoto from '../Shared/photo_not_found.png'

const OCIOUserRecord = (userData) => {
  const [apiURL, setApiURL] = useState('');
  const [photoError, setPhotoError] = useState(false);
  const apiRootURL = helper.getProxyRootURL();
  const renderKeyCell = (props) => <td style={{ whiteSpace: 'nowrap', verticalAlign: 'top'}}>{props.dataItem.key}</td>
  
  const renderValueCell = (props) => {
    const { dataItem, field } = props;
    const value = dataItem[field];

    if (typeof value === 'object') {
      return <td><pre>{JSON.stringify(value, null, 2)}</pre></td>;
    }

    return <td>{value}</td>;
  };

  useEffect(()=> {
    setApiURL(defaultPhoto)
    const osUidmId = userData.data.find((item => item['key'] === 'OSUIDMId'))
    if(userData && userData.data) {
        setApiURL(`${apiRootURL}Photo/ocio/OSUidmId=${osUidmId ? osUidmId.value : ''}`)
    }
  },[userData])

  return (
    <div>
      <h1>OCIO Record</h1>
      <div className='img-container'>
        {userData && !photoError
          ? <img height={125} src={apiURL} onError={() => setPhotoError(true)} alt="OCIO User" />
          : <img height={125} src={defaultPhoto} alt="No User Found" /> 
        }
      </div>
      {userData && (
        <>
          <Grid data={userData} resizable={true}>
              <GridColumn field="key" title="Key" width="250px" cell={renderKeyCell} />
              <GridColumn field="value" title="Value" cell={renderValueCell} />
          </Grid>
        </>
      )}
    </div>
  );
};

export default OCIOUserRecord;